import ContentLoader from 'react-content-loader';

export const Loader = () => (
  <div className='list-group-item border-0'>
    <ContentLoader
      speed={4}
      width={360}
      height={50}
      viewBox='0 0 360 50'
      backgroundColor='#e7e4e4'
      foregroundColor='#9a9ab1'
    >
      <circle cx='22' cy='26' r='22' />
      <rect x='56' y='7' rx='0' ry='0' width='87' height='14' />
      <rect x='55' y='30' rx='0' ry='0' width='181' height='16' />
      <rect x='134' y='42' rx='0' ry='0' width='21' height='0' />
    </ContentLoader>
  </div>
);
